import React from "react";
import Badge from "../../Badge";
import UpdateScopes from "../Roles/UpdateScopes";

export const getColumns = (intl) => [
  {
    title: "ID",
    field: "id",
    editable: "never",
    defaultSort: "desc",
    cellStyle: { fontSize: 12, padding: 0, minWidth: 100 },
  },
  {
    title: intl.formatMessage({ id: "name" }),
    field: "name",
    headerStyle: { minWidth: 200, fontWeight: "bold" },
    cellStyle: {
      fontSize: 12,
      padding: 0,
      minWidth: 200,
      textTransform: "uppercase",
      fontWeight: "bold",
    },
    editable: "never",
  },
  {
    cellStyle: { width: 600, minWidth: 600 },
    headerStyle: { width: 600, minWidth: 600 },
    title: "Scopes",
    field: "scopes",
    editComponent: (props) => <UpdateScopes {...props} />,
    render: ({ scopes }) =>
      !scopes ? (
        "-"
      ) : (
        <div>
          {scopes.split(";").map((s) => (
            <Badge classNames="mb-1 mr-1" text={s} key={s} />
          ))}
        </div>
      ),
  },
  {
    title: "Numero Utenti",
    field: "user_count",
    editable: "never",
    defaultSort: "desc",
    cellStyle: { fontSize: 12, padding: 0, minWidth: 100 },
  },
];

export const OPTIONS = {
  filtering: true,
  pageSize: 10,
  searchFieldAlignment: "left",
  searchFieldStyle: {
    marginTop: "2px",
  },
  showTitle: false,
  toolbar: false,
  filterCellStyle: { maxWidth: 250 },
  headerStyle: { whiteSpace: "nowrap", fontWeight: "bold" },
  cellStyle: { fontSize: 12, padding: 0, textTransform: "uppercase" },
};

export const getLocalization = (intl) => ({
  header: {
    actions: "",
  },
  body: {
    editRow: {
      deleteText: intl.formatMessage({ id: "delete_user" }),
    },
  },
  pagination: {
    labelDisplayedRows: "{from}-{to} of {count} users",
    labelRowsSelect: "Users",
  },
});
